export default __webpack_public_path__ + "static/media/blm-protest.abc0204c.jpg";